import { fetchGalleryImages } from '../../redux/slices/gallerySlice';
import { fetchCertificates } from '../../redux/slices/masterCertificatesSlice';
import { fetchMasterLogo } from '../../redux/slices/masterLogoSlice';
import { fetchSentSms } from '../../redux/slices/sendSms';
import { fetchSitemap } from '../../redux/slices/sitemapSlice';
import { fetchSurveyQuestions } from '../../redux/slices/surveyQuestionSlice';
import { fetchWaitlist } from '../../redux/slices/WaitlistSlice';

export const loadMasterMediaAndSurvey = async (masterId, dispatch) => {
    const promises = [
        dispatch(fetchGalleryImages(masterId)),
        dispatch(fetchSurveyQuestions(masterId)),
        dispatch(fetchCertificates(masterId)),
        dispatch(fetchWaitlist(masterId)),
        dispatch(fetchSitemap()),
        dispatch(fetchSentSms()),
        dispatch(fetchMasterLogo(masterId))
    ];

    await Promise.all(promises);
};
